import { number, object } from "yup";

export const bookingExpireSchema = object().shape({
  bookingExpiresIn: number().required().min(1)
});
